import type { Team } from "../models/Team";

export const NBA_TEAMS: Team[] = [
  { abbrev: "ATL", city: "Atlanta", name: "Hawks", nbaId: 1610612737 },
  { abbrev: "BOS", city: "Boston", name: "Celtics", nbaId: 1610612738 },
  { abbrev: "BKN", city: "Brooklyn", name: "Nets", nbaId: 1610612751 },
  { abbrev: "CHA", city: "Charlotte", name: "Hornets", nbaId: 1610612766 },
  { abbrev: "CHI", city: "Chicago", name: "Bulls", nbaId: 1610612741 },
  { abbrev: "CLE", city: "Cleveland", name: "Cavaliers", nbaId: 1610612739 },
  { abbrev: "DAL", city: "Dallas", name: "Mavericks", nbaId: 1610612742 },
  { abbrev: "DEN", city: "Denver", name: "Nuggets", nbaId: 1610612743 },
  { abbrev: "DET", city: "Detroit", name: "Pistons", nbaId: 1610612765 },
  { abbrev: "GSW", city: "Golden State", name: "Warriors", nbaId: 1610612744 },
  { abbrev: "HOU", city: "Houston", name: "Rockets", nbaId: 1610612745 },
  { abbrev: "IND", city: "Indiana", name: "Pacers", nbaId: 1610612754 },
  { abbrev: "LAC", city: "Los Angeles", name: "Clippers", nbaId: 1610612746 },
  { abbrev: "LAL", city: "Los Angeles", name: "Lakers", nbaId: 1610612747 },
  { abbrev: "MEM", city: "Memphis", name: "Grizzlies", nbaId: 1610612763 },
  { abbrev: "MIA", city: "Miami", name: "Heat", nbaId: 1610612748 },
  { abbrev: "MIL", city: "Milwaukee", name: "Bucks", nbaId: 1610612749 },
  { abbrev: "MIN", city: "Minnesota", name: "Timberwolves", nbaId: 1610612750 },
  { abbrev: "NOP", city: "New Orleans", name: "Pelicans", nbaId: 1610612740 },
  { abbrev: "NYK", city: "New York", name: "Knicks", nbaId: 1610612752 },
  { abbrev: "OKC", city: "Oklahoma City", name: "Thunder", nbaId: 1610612760 },
  { abbrev: "ORL", city: "Orlando", name: "Magic", nbaId: 1610612753 },
  { abbrev: "PHI", city: "Philadelphia", name: "76ers", nbaId: 1610612755 },
  { abbrev: "PHX", city: "Phoenix", name: "Suns", nbaId: 1610612756 },
  { abbrev: "POR", city: "Portland", name: "Trail Blazers", nbaId: 1610612757 },
  { abbrev: "SAC", city: "Sacramento", name: "Kings", nbaId: 1610612758 },
  { abbrev: "SAS", city: "San Antonio", name: "Spurs", nbaId: 1610612759 },
  { abbrev: "TOR", city: "Toronto", name: "Raptors", nbaId: 1610612761 },
  { abbrev: "UTA", city: "Utah", name: "Jazz", nbaId: 1610612762 },
  { abbrev: "WAS", city: "Washington", name: "Wizards", nbaId: 1610612764 },
];

export const GLEAGUE_TEAMS: Team[] = [
  { abbrev: "AUS", city: "Austin", name: "Spurs", nbaId: 1612709890 },
  { abbrev: "BIR", city: "Birmingham", name: "Squadron", nbaId: 1612709913 },
  { abbrev: "CCG", city: "Capital City", name: "Go-Go", nbaId: 1612709928 },
  { abbrev: "CLC", city: "Cleveland", name: "Charge", nbaId: 1612709893 },
  { abbrev: "CPS", city: "College Park", name: "Skyhawks", nbaId: 1612709929 },
  { abbrev: "DEL", city: "Delaware", name: "Blue Coats", nbaId: 1612709909 },
  { abbrev: "GLI", city: "G League", name: "Ignite", nbaId: 1612709930 },
  { abbrev: "GRG", city: "Grand Rapids", name: "Gold", nbaId: 1612709917 },
  { abbrev: "GBO", city: "Greensboro", name: "Swarm", nbaId: 1612709922 },
  { abbrev: "IMA", city: "Noblesville", name: "Boom", nbaId: 1612709910 },
  { abbrev: "IWA", city: "Iowa", name: "Wolves", nbaId: 1612709911 },
  { abbrev: "LIN", city: "Long Island", name: "Nets", nbaId: 1612709921 },
  { abbrev: "MNE", city: "Maine", name: "Celtics", nbaId: 1612709915 },
  { abbrev: "MHU", city: "Memphis", name: "Hustle", nbaId: 1612709926 },
  { abbrev: "MXC", city: "Mexico City", name: "Capitanes", nbaId: 1612709931 },
  { abbrev: "MCC", city: "Motor City", name: "Cruise", nbaId: 1612709932 },
  { abbrev: "OKL", city: "Oklahoma City", name: "Blue", nbaId: 1612709889 },
  { abbrev: "SDC", city: "San Diego", name: "Clippers", nbaId: 1612709924 },
  { abbrev: "OSC", city: "Osceola", name: "Magic", nbaId: 1612709925 },
  { abbrev: "RAP", city: "Raptors", name: "905", nbaId: 1612709920 },
  { abbrev: "RGV", city: "Rio Grande Valley", name: "Vipers", nbaId: 1612709908 },
  { abbrev: "RCR", city: "Rip City", name: "Remix", nbaId: 1612709933 },
  { abbrev: "SLC", city: "Salt Lake City", name: "Stars", nbaId: 1612709903 },
  { abbrev: "SCW", city: "Santa Cruz", name: "Warriors", nbaId: 1612709902 },
  { abbrev: "SXF", city: "Sioux Falls", name: "Skyforce", nbaId: 1612709904 },
  { abbrev: "SBL", city: "South Bay", name: "Lakers", nbaId: 1612709905 },
  { abbrev: "STO", city: "Stockton", name: "Kings", nbaId: 1612709914 },
  { abbrev: "TEX", city: "Texas", name: "Legends", nbaId: 1612709918 },
  { abbrev: "VAL", city: "Valley", name: "Suns", nbaId: 1612709934 },
  { abbrev: "WES", city: "Westchester", name: "Knicks", nbaId: 1612709919 },
  { abbrev: "WCB", city: "Windy City", name: "Bulls", nbaId: 1612709923 },
  { abbrev: "WIS", city: "Wisconsin", name: "Herd", nbaId: 1612709927 },
];

